import React from 'react'
import { Modal, useTheme } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'

import IconButton from './IconButton'

const CustomModal = ({ children, isOpen, onClose }) => {
  const theme = useTheme()

  return (
    <Modal open={isOpen}>
      <div css={`height: 100%; display: flex; justify-content: center; align-items: center;`}>
        <div css={`
          position: relative;
          background-color: ${theme.palette.background.paper};
          padding: 16px;
          border-radius: 4px;
          max-width: 572px;

          margin: 0 8px;

          &:focus {
            outline: none;
          }
        `}>
          <IconButton
            css={`
              position: absolute;
              top: -14px;
              right: -8px;
              color: black;
              background-color: white;
              border-radius: 50%;

              /* Override the normal IconButton hover */
              &:hover {
                color: black;
              }
            `}
            onClick={onClose}
          >
            <CancelIcon fontSize='large' color='inherit' />
          </IconButton>
          {children}
        </div>
      </div>
    </Modal>
  )
}

export default CustomModal
